export function routes($stateProvider) {
  $stateProvider
    .state('app.noticia', {
      url: '/noticia',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.noticia.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Notícias',
      template: require('./directory/directory.view.html'),
      controller: 'NoticiaListController',
      controllerAs: 'vm',
      role: 'noticiaRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.noticia.details', {
      url: '/{id}',
      title: 'Notícia',
      controller: 'NoticiaDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'noticiaRead'
    })
    .state('app.noticia.new', {
      url: '/nova',
      title: 'Adicionar Notícia',
      template: require('./new/new.view.html'),
      controller: 'NoticiaCreateNoticiaController',
      controllerAs: 'vm',
      role: 'noticiaCreate'
    })
    .state('app.noticia.new.1', {
      template: require('./new/noticia.1.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
